// @ts-ignore
import {ApiValidation} from "../../model/api/api-validation";
import {CrystalclearBackUrl} from "./crystalclear-back-url";
import {Contract} from "../../model/exchange/contract";
import {TableRecordResult} from "../../model/api/table-record-result";
import {ClearingHouse} from "../../model/exchange/clearing-house";
import {ExchangeDetail} from "../../model/exchange/exchange-detail";
import {AccountType} from "../../model/exchange/account-type";
import {TradingEnvironment} from "../../model/exchange/trading-environment";
import {MaturityRejectionRule} from "../../model/exchange/maturity-rejection-rule";
import {OwnerCode} from "../../model/exchange/owner-code";
import {BrokerCode} from "../../model/exchange/broker-code";

export class CrystalclearExchangeBackUrl {
  //clearinghouse
  static readonly GET_EXCHANGE_CLEARING_HOUSE_LIST: CrystalclearBackUrl.UrlConf<TableRecordResult<ClearingHouse>> = {
    url: '/api/exchange/clearing-house/list',
    type: TableRecordResult
  };

  static readonly SAVE_EXCHANGE_CLEARING_HOUSE: CrystalclearBackUrl.UrlConf<ApiValidation<ClearingHouse>> = {
    url: '/api/exchange/clearing-house/save',
    type: ApiValidation
  };

  static readonly DELETE_EXCHANGE_CLEARING_HOUSE: CrystalclearBackUrl.UrlConf<ApiValidation<any>> = {
    url: '/api/exchange/clearing-house/delete',
    type: ApiValidation
  };

  //exchange detail
  static readonly GET_EXCHANGE_EXCHANGE_DETAIL_LIST: CrystalclearBackUrl.UrlConf<TableRecordResult<ExchangeDetail>> = {
    url: '/api/exchange/exchange-detail/list',
    type: TableRecordResult
  };

  static readonly SAVE_EXCHANGE_EXCHANGE_DETAIL: CrystalclearBackUrl.UrlConf<ApiValidation<ExchangeDetail>> = {
    url: '/api/exchange/exchange-detail/save',
    type: ApiValidation
  };

  static readonly DELETE_EXCHANGE_EXCHANGE_DETAIL: CrystalclearBackUrl.UrlConf<ApiValidation<any>> = {
    url: '/api/exchange/exchange-detail/delete',
    type: ApiValidation
  };

  //account type
  static readonly GET_EXCHANGE_ACCOUNT_TYPE_LIST: CrystalclearBackUrl.UrlConf<TableRecordResult<AccountType>> = {
    url: '/api/exchange/account-type/list',
    type: TableRecordResult
  };

  static readonly SAVE_EXCHANGE_ACCOUNT_TYPE: CrystalclearBackUrl.UrlConf<ApiValidation<AccountType>> = {
    url: '/api/exchange/account-type/save',
    type: ApiValidation
  };

  static readonly DELETE_EXCHANGE_ACCOUNT_TYPE: CrystalclearBackUrl.UrlConf<ApiValidation<any>> = {
    url: '/api/exchange/account-type/delete',
    type: ApiValidation
  };

  //trading environment
  static readonly GET_EXCHANGE_TRADING_ENVIRONMENT_LIST: CrystalclearBackUrl.UrlConf<TableRecordResult<TradingEnvironment>> = {
    url: '/api/exchange/trading-environment/list',
    type: TableRecordResult
  };

  static readonly SAVE_EXCHANGE_TRADING_ENVIRONMENT: CrystalclearBackUrl.UrlConf<ApiValidation<TradingEnvironment>> = {
    url: '/api/exchange/trading-environment/save',
    type: ApiValidation
  };

  static readonly DELETE_EXCHANGE_TRADING_ENVIRONMENT: CrystalclearBackUrl.UrlConf<ApiValidation<any>> = {
    url: '/api/exchange/trading-environment/delete',
    type: ApiValidation
  };

  //contract
  static readonly GET_EXCHANGE_CONTRACT_LIST: CrystalclearBackUrl.UrlConf<TableRecordResult<Contract>> = {
    url: '/api/exchange/contract/list',
    type: TableRecordResult
  };

  static readonly SAVE_EXCHANGE_CONTRACT: CrystalclearBackUrl.UrlConf<ApiValidation<Contract>> = {
    url: '/api/exchange/contract/save',
    type: ApiValidation
  };

  static readonly DELETE_EXCHANGE_CONTRACT: CrystalclearBackUrl.UrlConf<ApiValidation<any>> = {
    url: '/api/exchange/contract/delete',
    type: ApiValidation
  };

  static readonly POST_EXCHANGE_CONTRACT_GET: CrystalclearBackUrl.UrlConf<ApiValidation<Contract[]>> = {
    url: '/api/exchange/contract/get-for-id-parts',
    type: ApiValidation
  };

  //maturity rejection rule
  static readonly GET_EXCHANGE_MATURITY_REJECTION_RULE_LIST: CrystalclearBackUrl.UrlConf<TableRecordResult<MaturityRejectionRule>> = {
    url: '/api/exchange/maturity-rejection-rule/list',
    type: TableRecordResult
  };

  static readonly SAVE_EXCHANGE_MATURITY_REJECTION_RULE: CrystalclearBackUrl.UrlConf<ApiValidation<MaturityRejectionRule>> = {
    url: '/api/exchange/maturity-rejection-rule/save',
    type: ApiValidation
  };

  static readonly DELETE_EXCHANGE_MATURITY_REJECTION_RULE: CrystalclearBackUrl.UrlConf<ApiValidation<any>> = {
    url: '/api/exchange/maturity-rejection-rule/delete',
    type: ApiValidation
  };

  //owner code
  static readonly GET_EXCHANGE_OWNER_CODE_LIST: CrystalclearBackUrl.UrlConf<TableRecordResult<OwnerCode>> = {
    url: '/api/exchange/owner-code/list',
    type: TableRecordResult
  };

  static readonly SAVE_EXCHANGE_OWNER_CODE: CrystalclearBackUrl.UrlConf<ApiValidation<OwnerCode>> = {
    url: '/api/exchange/owner-code/save',
    type: ApiValidation
  };

  static readonly DELETE_EXCHANGE_OWNER_CODE: CrystalclearBackUrl.UrlConf<ApiValidation<any>> = {
    url: '/api/exchange/owner-code/delete',
    type: ApiValidation
  };

  //broker code
  static readonly GET_EXCHANGE_BROKER_CODE_LIST: CrystalclearBackUrl.UrlConf<TableRecordResult<BrokerCode>> = {
    url: '/api/exchange/broker-code/list',
    type: TableRecordResult
  };

  static readonly SAVE_EXCHANGE_BROKER_CODE: CrystalclearBackUrl.UrlConf<ApiValidation<BrokerCode>> = {
    url: '/api/exchange/broker-code/save',
    type: ApiValidation
  };

  static readonly DELETE_EXCHANGE_BROKER_CODE: CrystalclearBackUrl.UrlConf<ApiValidation<any>> = {
    url: '/api/exchange/broker-code/delete',
    type: ApiValidation
  };

}
